import { PubSubActions } from "@/global/pubsub-actions.ts";

export interface LogoutMessageLogout {
  logout?: boolean;
}

export interface LogoutMessageReload {
  reload?: boolean;
}

export type LogoutMessage = LogoutMessageLogout & LogoutMessageReload;

export let broadcast_logout: BroadcastChannel | null = new BroadcastChannel(PubSubActions.LOGOUT);

export function open() {
  if (broadcast_logout == null) {
    broadcast_logout = new BroadcastChannel(PubSubActions.LOGOUT);
  }
}

export function close() {
  if (broadcast_logout != null) {
    broadcast_logout.close();
    broadcast_logout = null;
  }
}
